import { IconButton, Flex, Tooltip } from '@cad-arc';
import React from 'react';
import classnames from 'classnames';
import styles from './narrative-jump-buttons.module.css';

const INACTIVE_OPACITY = 0.4;
const ACTIVE_OPACITY = 1;

export interface NarrativeJumpButtonsProps {
    onScrollToTop: () => void;
    onScrollToBottom: () => void;
    isAtTop?: boolean;
    isAtBottom?: boolean;
    isFirstResponder?: boolean;
    isDisabled?: boolean;
    isAscLayout?: boolean;
}

export function NarrativeJumpButtons({
    onScrollToTop,
    onScrollToBottom,
    isDisabled,
    isAscLayout,
    isAtTop = false,
    isAtBottom = false,
    isFirstResponder = false,
}: NarrativeJumpButtonsProps): React.JSX.Element {
    const size = isFirstResponder ? 'lg' : 'sm';
    const topLabel = isAscLayout ? 'Go to oldest message' : 'Go to newest message';
    const bottomLabel = isAscLayout ? 'Go to newest message' : 'Go to oldest message';

    return (
        <Flex
            direction={isFirstResponder ? 'column' : 'row'}
            gap="var(--arc-space-0.5)"
            data-testid="NARRATIVE_JUMP_BUTTONS"
        >
            <Tooltip content={topLabel}>
                <IconButton
                    data-testid="NARRATIVE_JUMP_TO_TOP"
                    className={classnames(styles['jump-button'], {
                        [styles['inactive']]: isAtTop,
                    })}
                    colorVariant="white"
                    icon="VerticalAlignTop"
                    variant="ghost"
                    _hover={{ opacity: ACTIVE_OPACITY }}
                    aria-label={topLabel}
                    title={topLabel}
                    opacity={isAtTop ? INACTIVE_OPACITY : ACTIVE_OPACITY}
                    size={size}
                    isDisabled={isDisabled}
                    tabIndex={-1}
                    onClick={onScrollToTop}
                />
            </Tooltip>
            <Tooltip content={bottomLabel}>
                <IconButton
                    data-testid="NARRATIVE_JUMP_TO_BOTTOM"
                    className={classnames(styles['jump-button'], {
                        [styles['inactive']]: isAtBottom,
                    })}
                    colorVariant="white"
                    icon="VerticalAlignBottom"
                    variant="ghost"
                    _hover={{ opacity: ACTIVE_OPACITY }}
                    aria-label={bottomLabel}
                    title={bottomLabel}
                    opacity={isAtBottom ? INACTIVE_OPACITY : ACTIVE_OPACITY}
                    size={size}
                    isDisabled={isDisabled}
                    tabIndex={-1}
                    onClick={onScrollToBottom}
                />
            </Tooltip>
        </Flex>
    );
}
